

import { AlertModalController } from './Generic/AlertModal/AlertModalController';
import { ConfirmModalController } from './Generic/ConfirmModal/ConfirmModalController';
import { LoadingModalController } from './Generic/LoadingModal/LoadingModalController';
import { ConfirmRedeemModalController } from './ConfirmRedeemModal/ConfirmRedeemModalController';
import { SerialModalController } from './SerialModal/SerialModalController';
import { DrawDeliveryModalController } from './DrawDeliveryModal/DrawDeliveryModalController';
import { ShippingAddressModalController } from './ShippingAddressModal/ShippingAddressModalController';



export function useModalSetup (modalStore)  {
    // modalController.value
    const modalController = modalStore.methods.getModalController()

    const initModal = function () {
        //Generic
        modalController.setAlertModal(new AlertModalController());
        modalController.setConfirmModal(new ConfirmModalController());
        modalController.setLoadingModal(new LoadingModalController());
        //Redeem
        modalController.setConfirmRedeemModal(new ConfirmRedeemModalController());
        modalController.setSerialModal(new SerialModalController());
        modalController.setDrawDeliveryModal(new DrawDeliveryModalController());
        modalController.setShippingAddressModal(new ShippingAddressModalController());
        
        return modalController;
    }

    return {
        initModal
    }
}
